/**
 * Main Layout Component
 *
 * Wraps authenticated pages with the application header.
 */

import { type ReactElement, type ReactNode } from 'react';
import { Header } from '../Header';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps): ReactElement {
  return (
    <div className="main-layout">
      <Header />
      <div className="main-layout__content">{children}</div>
    </div>
  );
}
